import React from "react"
import { connect } from "react-redux"
import Modal from "buoy-modal"

const MessageConfirm = ({
  heading,
  message,
  submitText,
  submitClick,
  showCancel,
  cancelClick,
  show,
}) =>
  show ? (
    <Modal
      heading={heading}
      message={message}
      showSubmit={true}
      submitText={submitText}
      submitClick={submitClick}
      showCancel={showCancel}
      cancelText="Cancel"
      cancelClick={cancelClick}
    />
  ) : (
    <span />
  )

const mapStateToProps = state => ({
  heading: state.modals.confirmMessage.heading,
  message: state.modals.confirmMessage.message,
  submitText: state.modals.confirmMessage.submitText,
  submitClick: state.modals.confirmMessage.submitClick,
  showCancel: state.modals.confirmMessage.showCancel,
  cancelClick: state.modals.confirmMessage.cancelClick,
  show: state.modals.confirmMessageShown,
})

const MessageConfirmModal = connect(mapStateToProps)(MessageConfirm)

export { MessageConfirmModal as default, MessageConfirm }



// WEBPACK FOOTER //
// ./assets/modals/MessageConfirmModal.js